import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import Lineup from './Lineup';
import { normalizeSearchText, normalizePlayerIdentifier, matchesSearch } from '../../common/utils/normalize';
export default class LineupModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "players", void 0);
    _defineProperty(this, "selectedPlayers", void 0);
    _defineProperty(this, "formation", void 0);
    _defineProperty(this, "kit", void 0);
    _defineProperty(this, "step", void 0);
    _defineProperty(this, "filter", void 0);
    _defineProperty(this, "activePosition", void 0);
    _defineProperty(this, "searchQuery", void 0);
    _defineProperty(this, "selectedTeamId", void 0);
    _defineProperty(this, "kits", [{
      id: 'athletic',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.athletic')
    }, {
      id: 'athletic-away',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.athletic_away'),
      color: '#0060A9'
    }, {
      id: 'rayo',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.rayo')
    }, {
      id: 'azulgrana',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.azulgrana')
    }, {
      id: 'gualdinegro',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.gualdinegro')
    }, {
      id: 'blanquinegro',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.blanquinegro')
    }, {
      id: 'naranjanegro',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.naranjanegro')
    }, {
      id: 'celeste',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.celeste'),
      color: '#7ed6df'
    }, {
      id: 'granate',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.granate'),
      color: '#6D214F'
    }, {
      id: 'rosa',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.rosa'),
      color: '#ff9ff3'
    }, {
      id: 'white',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.white'),
      color: '#ffffff'
    }, {
      id: 'red',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.red'),
      color: '#EE2523'
    }, {
      id: 'blue',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.blue'),
      color: '#0060A9'
    }, {
      id: 'green',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.green'),
      color: '#009432'
    }, {
      id: 'yellow',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.yellow'),
      color: '#FFC312'
    }, {
      id: 'black',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.black'),
      color: '#1e272e'
    }, {
      id: 'orange',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.orange'),
      color: '#F79F1F'
    }, {
      id: 'purple',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.purple'),
      color: '#9980FA'
    }, {
      id: 'stripes-blue-white',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.stripes_blue_white')
    }, {
      id: 'stripes-green-white',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.stripes_green_white')
    }, {
      id: 'stripes-red-black',
      name: app.translator.trans('bizkaitarra-lineup.forum.modal.kits.stripes_red_black')
    }]);
    _defineProperty(this, "recentLineups", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.players = [];
    this.selectedPlayers = new Array(11).fill(null).map(() => ({
      number: Stream(''),
      name: Stream(''),
      id: Stream('')
    }));
    this.formation = Stream('4-4-2');
    const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
    this.kit = Stream(isRealSociedad ? 'stripes-blue-white' : 'athletic');
    if (isRealSociedad) {
      const stripesKit = this.kits.find(k => k.id === 'stripes-blue-white');
      if (stripesKit) {
        stripesKit.name = 'Real Sociedad';
        this.kits = [stripesKit, ...this.kits.filter(k => k.id !== 'stripes-blue-white')];
      }
      const athleticKit = this.kits.find(k => k.id === 'athletic');
      if (athleticKit) {
        athleticKit.name = 'Rayas Rojo/Blanco';
      }
      const athleticAwayKit = this.kits.find(k => k.id === 'athletic-away');
      if (athleticAwayKit) {
        athleticAwayKit.name = 'Azul';
      }
    }
    this.step = Stream('players');
    this.filter = Stream('');
    this.activePosition = Stream(0);
    this.searchQuery = Stream('');
    const primaryTeamId = this.attrs.match && typeof this.attrs.match.teamId === 'function' && this.attrs.match.teamId() ? String(this.attrs.match.teamId()) : app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
    if (this.attrs.onlyStarters) {
      this.selectedTeamId = Stream('all');
      this.kit(isRealSociedad ? 'stripes-blue-white' : 'athletic');
    } else {
      this.selectedTeamId = Stream('all');
    }
    this.editorMode = Stream('lineup');
    this.squadStep = Stream('list');
    this.newGroupName = Stream('');
    this.squadGroups = [];
    this.activeGroupIndex = Stream(0);
    this.activeSquadPlayerIndex = Stream(0);
    this.loadPlayers();
    this.loadRecentLineups();
    if (this.attrs.lineup) {
      this.loadLineup(this.attrs.lineup);
    } else {
      this.loadLastSavedLineup();
    }
  }
  className() {
    return 'LineupModal Modal--large';
  }
  title() {
    if (this.editorMode && this.editorMode() === 'squad') {
      return app.translator.trans('bizkaitarra-lineup.forum.modal.title_squad');
    }
    return app.translator.trans('bizkaitarra-lineup.forum.modal.title');
  }
  view() {
    return m('div', {
      className: 'Modal modal-dialog ' + this.className()
    }, [m('div', {
      className: 'Modal-content'
    }, [m('div', {
      className: 'Modal-header'
    }, [
    // Close button on the left
    m(Button, {
      className: 'Button Button--icon Button--link Modal-close-left',
      icon: 'fas fa-times',
      onclick: this.hide.bind(this)
    }),
    // Centered Title
    m('h3.Modal-title', this.title()),
    // "Insertar" button on the right
    m(Button, {
      className: 'Button Button--primary Modal-action-right',
      icon: 'fas fa-check',
      onclick: this.insertLineup.bind(this)
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.insert_button'))]),
    // Tabs selection (only show if not onlyStarters)
    !this.attrs.onlyStarters && m('.LineupModal-tabs', [m('button.LineupModal-tab', {
      className: this.editorMode() === 'lineup' ? 'active' : '',
      type: 'button',
      onclick: () => {
        this.editorMode('lineup');
        this.saveDraft();
      }
    }, [m('i.fas.fa-futbol'), ' Alineación']), m('button.LineupModal-tab', {
      className: this.editorMode() === 'squad' ? 'active' : '',
      type: 'button',
      onclick: () => {
        this.editorMode('squad');
        this.saveDraft();
      }
    }, [m('i.fas.fa-users'), ' Plantilla'])]), this.content()])]);
  }
  getPositionName(index) {
    if (index >= 11) {
      return "Suplente ".concat(index - 10);
    }
    const formation = this.formation();
    const positions = {
      '4-4-2': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'lm', 'cm1', 'cm2', 'rm', 'st1', 'st2'],
      '4-3-3': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'centrocampista_l', 'dm', 'centrocampista_r', 'lw', 'stc', 'rw'],
      '4-2-3-1': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'piv_l', 'piv_r', 'lw', 'cam', 'rw', 'stc'],
      '4-1-4-1': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'dm', 'interior_l', 'vol_l', 'vol_r', 'interior_r', 'stc'],
      '4-5-1': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'interior_l', 'centrocampista_l', 'cm', 'centrocampista_r', 'interior_r', 'stc'],
      '3-5-2': ['gk', 'cbl', 'sw', 'cbr', 'lwb', 'interior_l', 'cm', 'interior_r', 'rwb', 'st1', 'st2'],
      '3-4-3': ['gk', 'cbl', 'sw', 'cbr', 'lwb', 'centrocampista_l', 'centrocampista_r', 'rwb', 'lw', 'stc', 'rw'],
      '5-3-2': ['gk', 'lwb', 'cb1', 'sw', 'cb2', 'rwb', 'centrocampista_l', 'cm', 'centrocampista_r', 'st1', 'st2'],
      '5-4-1': ['gk', 'lwb', 'cb1', 'sw', 'cb2', 'rwb', 'interior_l', 'centrocampista_l', 'centrocampista_r', 'interior_r', 'stc'],
      '4-3-1-2': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'interior_l', 'dm', 'interior_r', 'cam', 'st1', 'st2'],
      '4-2-2-2': ['gk', 'lb', 'cb1', 'cb2', 'rb', 'piv_l', 'piv_r', 'cam_l', 'cam_r', 'st1', 'st2'],
      '3-1-4-2': ['gk', 'cbl', 'sw', 'cbr', 'dm', 'lwb', 'interior_l', 'interior_r', 'rwb', 'st1', 'st2']
    };
    const posKey = positions[formation] ? positions[formation][index] : null;
    if (posKey) {
      return app.translator.trans("bizkaitarra-lineup.forum.modal.positions.".concat(posKey));
    }
    return app.translator.trans('bizkaitarra-lineup.forum.modal.positions.player', {
      number: index + 1
    });
  }
  loadPlayers() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players?active=1"
    }).then(response => {
      const allPlayers = app.store.pushPayload(response) || [];
      this.players = allPlayers.filter(p => typeof p.isActive === 'function' ? p.isActive() !== false : true);
      m.redraw();
    });
  }
  getTeams() {
    const teamsMap = new Map();
    this.players.forEach(p => {
      if (p.attribute('entityType') !== 'player') return;
      if (typeof p.isActive === 'function' && p.isActive() === false) return;
      const teams = p.teams() || [];
      teams.forEach(t => {
        if (t && t.id() && t.name()) {
          teamsMap.set(String(t.id()), t);
        }
      });
    });
    return Array.from(teamsMap.values()).sort((a, b) => a.name().localeCompare(b.name()));
  }
  getAllowedTeamIds() {
    const primaryTeamId = this.attrs.match && typeof this.attrs.match.teamId === 'function' && this.attrs.match.teamId() ? String(this.attrs.match.teamId()) : String(app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531');
    const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
    if (isRealSociedad) {
      return [primaryTeamId];
    }

    // Athletic Club: Primer equipo (531), Bilbao Athletic (9579) y Basconia (9656)
    const allowedIds = new Set([primaryTeamId, '531', '9579', '9656']);
    this.getTeams().forEach(team => {
      const name = (team.name() || '').toLowerCase();
      const id = String(team.id());
      if (id === '1905' || name.includes('femenino') || name.includes('club w')) {
        return;
      }
      if (name === 'athletic club' || name === 'bilbao athletic' || name.includes('basconia')) {
        allowedIds.add(id);
      }
    });
    return Array.from(allowedIds);
  }
  getAllowedTeams() {
    const allowedIds = this.getAllowedTeamIds();
    return this.getTeams().filter(team => allowedIds.includes(String(team.id())));
  }
  getPlayerPriorityScore(player, activeIdx) {
    const pos = activeIdx + 1; // 1-11
    const formation = this.formation();
    const positions = player.attribute('lineupPositions') || [];
    let score = 0;
    for (const pPos of positions) {
      if (pPos.formation === formation) {
        if (pPos.position === pos) {
          score = Math.max(score, 1000 + pPos.priority);
        } else if (pPos.position === pos - 1 || pPos.position === pos + 1) {
          score = Math.max(score, 100 + pPos.priority);
        }
      }
    }
    return score;
  }
  getSelectedPlayerNames(excludeIdx) {
    if (excludeIdx === void 0) {
      excludeIdx = -1;
    }
    if (this.editorMode() === 'squad') {
      const names = [];
      this.squadGroups.forEach((g, gIdx) => {
        g.players.forEach((p, pIdx) => {
          if (gIdx === this.activeGroupIndex() && pIdx === excludeIdx) {
            return;
          }
          if (p.name()) {
            names.push(normalizePlayerIdentifier(p.name()));
          }
        });
      });
      return names;
    }
    return this.selectedPlayers.map((p, idx) => {
      if (idx === excludeIdx) return '';
      return p.name() ? normalizePlayerIdentifier(p.name()) : '';
    }).filter(name => name !== '');
  }
  getSuggestions(query, type, activeIdx) {
    if (!query || query.length < 1) return [];
    const normalizedQuery = normalizeSearchText(query);
    const selectedNames = this.getSelectedPlayerNames(activeIdx);
    const filtered = this.players.filter(p => {
      if (p.attribute('entityType') !== 'player') {
        return false;
      }
      if (typeof p.isActive === 'function' && p.isActive() === false) {
        return false;
      }

      // Exclude already selected players in other positions
      if (selectedNames.includes(normalizePlayerIdentifier(p.name()))) {
        return false;
      }
      if (this.attrs.onlyStarters) {
        const allowedTeamIds = this.getAllowedTeamIds();
        const playerTeams = p.teams() || [];
        const belongsToAllowed = playerTeams.length === 0 || playerTeams.some(t => allowedTeamIds.includes(String(t.id())));
        if (!belongsToAllowed) {
          return false;
        }
      }
      if (this.selectedTeamId() && this.selectedTeamId() !== 'all') {
        const playerTeams = p.teams() || [];
        const belongsToTeam = playerTeams.some(t => String(t.id()) === String(this.selectedTeamId()));
        if (!belongsToTeam) {
          return false;
        }
      }
      if (type === 'number') {
        const val = p.number() ? p.number().toString() : '';
        return val.includes(normalizedQuery);
      } else {
        // Search in name (accent-insensitive)
        const nameMatch = matchesSearch(p.name(), normalizedQuery);
        if (nameMatch) return true;

        // Search in aliases (semicolon or comma separated, accent-insensitive)
        const aliases = (p.attribute('aliases') || '').split(/[;,]/);
        return aliases.some(alias => matchesSearch(alias, normalizedQuery));
      }
    });
    return filtered.sort((a, b) => {
      const scoreA = this.getPlayerPriorityScore(a, activeIdx);
      const scoreB = this.getPlayerPriorityScore(b, activeIdx);
      if (scoreA !== scoreB) {
        return scoreB - scoreA;
      }
      const numA = parseInt(a.number() || '99');
      const numB = parseInt(b.number() || '99');
      return numA - numB;
    }).slice(0, 5);
  }
  saveDraft() {
    const draft = {
      editorMode: this.editorMode ? this.editorMode() : 'lineup',
      formation: this.formation(),
      kit: this.kit(),
      players: this.selectedPlayers.map(p => ({
        number: p.number(),
        name: p.name(),
        id: p.id ? p.id() : ''
      })),
      squadGroups: this.squadGroups ? this.squadGroups.map(g => ({
        title: g.title(),
        players: g.players.map(p => ({
          number: p.number(),
          name: p.name()
        }))
      })) : [],
      activeGroupIndex: this.activeGroupIndex ? this.activeGroupIndex() : 0,
      activeSquadPlayerIndex: this.activeSquadPlayerIndex ? this.activeSquadPlayerIndex() : 0
    };
    localStorage.setItem('nagusi_lineup_draft', JSON.stringify(draft));
  }
  loadLastSavedLineup() {
    const saved = localStorage.getItem('nagusi_lineup_draft');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        // We don't restore editorMode so that it always defaults to 'lineup' as requested.
        // if (data.editorMode) this.editorMode(data.editorMode);
        if (data.formation) this.formation(data.formation);
        if (data.kit) this.kit(data.kit);
        if (data.players && Array.isArray(data.players)) {
          const onlyStarters = this.attrs.onlyStarters;
          const targetLength = onlyStarters ? 11 : Math.max(11, data.players.length);
          while (this.selectedPlayers.length < targetLength) {
            this.selectedPlayers.push({
              number: Stream(''),
              name: Stream(''),
              id: Stream('')
            });
          }
          data.players.forEach((p, i) => {
            if (onlyStarters && i >= 11) return;
            if (this.selectedPlayers[i]) {
              this.selectedPlayers[i].number(p.number || '');
              this.selectedPlayers[i].name(p.name || '');
              if (this.selectedPlayers[i].id) {
                this.selectedPlayers[i].id(p.id || '');
              }
            }
          });
        }
        if (data.squadGroups && Array.isArray(data.squadGroups)) {
          this.squadGroups = data.squadGroups.map(g => ({
            title: Stream(g.title || ''),
            players: (g.players || []).map(p => ({
              number: Stream(p.number || ''),
              name: Stream(p.name || '')
            }))
          }));
        }
        if (typeof data.activeGroupIndex !== 'undefined') this.activeGroupIndex(data.activeGroupIndex);
        if (typeof data.activeSquadPlayerIndex !== 'undefined') this.activeSquadPlayerIndex(data.activeSquadPlayerIndex);
        m.redraw();
      } catch (e) {
        console.error("Error loading lineup draft:", e);
      }
    }
  }
  loadRecentLineups() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/my-recent-lineups'
    }).then(data => {
      this.recentLineups = data || [];
      m.redraw();
    }).catch(err => {
      console.error("Error loading recent lineups:", err);
    });
  }
  loadLineup(lineup) {
    if (!lineup) return;

    // Handle both Flarum model and plain object
    const formation = typeof lineup.formation === 'function' ? lineup.formation() : lineup.formation;
    const kit = typeof lineup.kit === 'function' ? lineup.kit() : lineup.kit;
    const playersRaw = typeof lineup.playersRaw === 'function' ? lineup.playersRaw() : lineup.players_raw || lineup.playersRaw;
    if (formation) this.formation(formation);
    if (kit && !this.attrs.onlyStarters) this.kit(kit);
    if (playersRaw) {
      const playersList = playersRaw.split(',');
      const onlyStarters = this.attrs.onlyStarters;
      const targetLength = onlyStarters ? 11 : Math.max(11, playersList.length);
      while (this.selectedPlayers.length < targetLength) {
        this.selectedPlayers.push({
          number: Stream(''),
          name: Stream(''),
          id: Stream('')
        });
      }
      playersList.forEach((pStr, i) => {
        if (onlyStarters && i >= 11) return;
        if (this.selectedPlayers[i]) {
          if (pStr.includes(':')) {
            const parts = pStr.split(':');
            if (parts.length >= 3 && !isNaN(Number(parts[1]))) {
              const number = parts[0] === '?' ? '' : parts[0];
              const id = parts[1];
              const name = parts.slice(2).join(':') === '?' ? '' : parts.slice(2).join(':');
              this.selectedPlayers[i].number(number);
              if (this.selectedPlayers[i].id) this.selectedPlayers[i].id(id);
              this.selectedPlayers[i].name(name);
            } else {
              const number = parts[0] === '?' ? '' : parts[0];
              const name = parts.slice(1).join(':') === '?' ? '' : parts.slice(1).join(':');
              this.selectedPlayers[i].number(number);
              if (this.selectedPlayers[i].id) this.selectedPlayers[i].id('');
              this.selectedPlayers[i].name(name);
            }
          } else {
            this.selectedPlayers[i].number('');
            if (this.selectedPlayers[i].id) this.selectedPlayers[i].id('');
            this.selectedPlayers[i].name(pStr === '?' ? '' : pStr);
          }
        }
      });
    }
    this.saveDraft();
    m.redraw();
  }
  clearLineup() {
    if (this.editorMode() === 'squad') {
      const defaultTitle = app.translator.trans('bizkaitarra-lineup.forum.modal.squad.suggested_title_goalkeeper').toString() || 'Porteros';
      this.squadGroups = [{
        title: Stream(defaultTitle),
        players: [{
          number: Stream(''),
          name: Stream('')
        }]
      }];
      this.activeGroupIndex(0);
      this.activeSquadPlayerIndex(0);
    } else {
      this.selectedPlayers = this.selectedPlayers.slice(0, 11);
      this.selectedPlayers.forEach(p => {
        p.name('');
        p.number('');
        if (p.id) p.id('');
      });
      this.activePosition(0);
    }
    this.searchQuery('');
    this.saveDraft();
    m.redraw();
  }
  advanceFrom(index) {
    let nextIdx = index + 1;
    if (nextIdx >= this.selectedPlayers.length) {
      if (this.attrs.onlyStarters) {
        nextIdx = 0;
      } else {
        this.selectedPlayers.push({
          number: Stream(''),
          name: Stream(''),
          id: Stream('')
        });
        this.saveDraft();
      }
    }
    this.activePosition(nextIdx);
    this.searchQuery('');
    m.redraw();
    setTimeout(() => {
      const input = document.getElementById('lineup-player-search');
      if (input) {
        input.focus();
        input.select();
      }
    }, 50);
  }
  commitOrAdvance(index) {
    if (this.editorMode() === 'squad') {
      this.advanceSquadPlayer();
      return;
    }

    // Only enforce in 11 Aldeanos mode (onlyStarters === true)
    if (this.attrs.onlyStarters) {
      const activePlayer = this.selectedPlayers[index];
      const currentName = (this.searchQuery() || (activePlayer ? activePlayer.name() : '') || '').trim();
      if (!currentName) {
        this.advanceFrom(index);
        return;
      }
      const currentId = activePlayer && activePlayer.id ? activePlayer.id() : '';

      // If player already has a valid ID that corresponds to this player
      if (currentId && this.players) {
        const pObj = this.players.find(p => String(p.id()) === String(currentId));
        if (pObj) {
          const normTyped = normalizePlayerIdentifier(currentName);
          const normPName = normalizePlayerIdentifier(pObj.name());
          const aliases = (pObj.attribute('aliases') || '').split(/[,;]/).map(a => normalizePlayerIdentifier(a));
          if (normTyped === normPName || aliases.includes(normTyped)) {
            this.advanceFrom(index);
            return;
          }
        }
      }

      // Otherwise, attempt to find matching player in this.players
      const norm = normalizePlayerIdentifier(currentName);
      const suggestions = this.getSuggestions(currentName, 'name', index);
      let matchedPlayer = suggestions && suggestions.length > 0 ? suggestions[0] : null;
      if (!matchedPlayer && this.players) {
        matchedPlayer = this.players.find(p => {
          const pName = normalizePlayerIdentifier(p.name());
          if (pName === norm) return true;
          const aliases = (p.attribute('aliases') || '').split(/[,;]/).map(a => normalizePlayerIdentifier(a));
          return aliases.includes(norm);
        });
      }
      if (matchedPlayer) {
        const allowedTeamIds = this.getAllowedTeamIds();
        const playerTeams = matchedPlayer.teams() || [];
        const belongsToAllowed = playerTeams.length === 0 || playerTeams.some(t => allowedTeamIds.includes(String(t.id())));
        if (!belongsToAllowed) {
          const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
          const msg = isRealSociedad ? "El jugador \"".concat(matchedPlayer.name(), "\" no pertenece a la plantilla de la Real Sociedad.") : "El jugador \"".concat(matchedPlayer.name(), "\" debe pertenecer al primer equipo, Bilbao Athletic o Basconia.");
          app.alerts.show({
            type: 'error'
          }, msg);
          return;
        }
        const matchedId = matchedPlayer.id() ? String(matchedPlayer.id()) : '';
        // Verificar si ya está seleccionado en otra posición
        const isAlreadySelected = this.selectedPlayers.some((p, pIdx) => {
          if (pIdx === index) return false;
          const pid = p.id ? p.id() : '';
          if (matchedId && pid && String(pid) === matchedId) return true;
          return normalizePlayerIdentifier(p.name()) === normalizePlayerIdentifier(matchedPlayer.name());
        });
        if (isAlreadySelected) {
          app.alerts.show({
            type: 'error'
          }, "El jugador \"".concat(matchedPlayer.name(), "\" ya est\xE1 seleccionado en otra posici\xF3n del once titular."));
          return;
        }
        this.selectPlayer(matchedPlayer.name(), matchedPlayer.number() ? matchedPlayer.number().toString() : '', matchedId);
        return;
      }
      app.alerts.show({
        type: 'error'
      }, "El jugador \"".concat(currentName, "\" no pertenece a la plantilla del club."));
      return;
    }
    this.advanceFrom(index);
  }
  selectPlayer(name, number, id) {
    if (id === void 0) {
      id = '';
    }
    if (this.editorMode() === 'squad') {
      const gIdx = this.activeGroupIndex();
      const pIdx = this.activeSquadPlayerIndex();
      const activeGroup = this.squadGroups[gIdx];
      if (activeGroup && activeGroup.players[pIdx]) {
        activeGroup.players[pIdx].number(number);
        activeGroup.players[pIdx].name(name);
        this.saveDraft();
        this.advanceSquadPlayer();
      }
    } else {
      const index = this.activePosition();
      this.selectedPlayers[index].number(number);
      this.selectedPlayers[index].name(name);
      if (this.selectedPlayers[index].id) {
        this.selectedPlayers[index].id(id);
      }
      this.saveDraft();
      this.advanceFrom(index);
    }
  }
  advanceSquadPlayer() {
    const gIdx = this.activeGroupIndex();
    const pIdx = this.activeSquadPlayerIndex();
    const activeGroup = this.squadGroups[gIdx];
    if (!activeGroup) return;
    let nextPIdx = pIdx + 1;
    if (nextPIdx >= activeGroup.players.length) {
      activeGroup.players.push({
        number: Stream(''),
        name: Stream('')
      });
      this.saveDraft();
    }
    this.activeSquadPlayerIndex(nextPIdx);
    this.searchQuery('');
    m.redraw();
    setTimeout(() => {
      const input = document.getElementById('lineup-player-search');
      if (input) {
        input.focus();
        input.select();
      }
    }, 50);
  }
  addGroup(title) {
    this.squadGroups.push({
      title: Stream(title),
      players: [{
        number: Stream(''),
        name: Stream('')
      }]
    });
    this.activeGroupIndex(this.squadGroups.length - 1);
    this.activeSquadPlayerIndex(0);
    this.searchQuery('');
    this.squadStep('edit_group_players');
    this.saveDraft();
    m.redraw();
    setTimeout(() => {
      const input = document.getElementById("squad-player-name-".concat(this.activeGroupIndex(), "-0"));
      if (input) {
        input.focus();
      }
    }, 100);
  }
  renderSquadPreview() {
    const step = this.squadStep();
    let content;
    if (step === 'create_group_name') {
      content = this.renderSquadGroupNameForm();
    } else if (step === 'edit_group_players') {
      content = this.renderSquadGroupPlayersEditor();
    } else {
      content = this.renderSquadGroupsList();
    }
    return m('.LineupModal-squad-preview', {
      className: "squad-step-".concat(step)
    }, content);
  }
  renderSquadGroupsList() {
    return m('.LineupModal-squad-groups-list', [m('.list-header', [m('span.list-header-title', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.group_list_title')), m('span.list-header-help', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.group_list_help'))]), m('.groups-container', [this.squadGroups.length === 0 ? m('.empty-groups-state', [m('i.fas.fa-users-cog', {
      style: {
        fontSize: '2.5rem',
        marginBottom: '15px',
        color: '#94a3b8'
      }
    }), m('p', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.empty_state')), m('p.help', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.empty_state_help'))]) : m('.groups-grid', this.squadGroups.map((group, gIdx) => {
      const validPlayers = group.players.filter(p => p.name() && p.name().trim() !== '' && p.name() !== '?');
      return m('.group-list-row', [m('.group-info', [m('.group-title-row', [m('span.group-name', group.title()), m('span.group-badge', validPlayers.length === 1 ? app.translator.trans('bizkaitarra-lineup.forum.modal.squad.player_single') : app.translator.trans('bizkaitarra-lineup.forum.modal.squad.players_plural', {
        count: validPlayers.length
      }))]), validPlayers.length > 0 ? m('.group-preview-players', validPlayers.map(p => p.name()).join(', ')) : m('.group-preview-players.empty', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.no_players'))]), m('.group-actions', [m(Button, {
        className: 'Button Button--icon Button--secondary edit-btn',
        icon: 'fas fa-pencil-alt',
        title: app.translator.trans('bizkaitarra-lineup.forum.modal.squad.edit_members_title'),
        type: 'button',
        onclick: e => {
          e.stopPropagation();
          this.activeGroupIndex(gIdx);
          this.activeSquadPlayerIndex(0);
          this.searchQuery('');
          this.squadStep('edit_group_players');
          m.redraw();
        }
      }), m(Button, {
        className: 'Button Button--icon Button--secondary delete-btn',
        icon: 'fas fa-trash',
        title: app.translator.trans('bizkaitarra-lineup.forum.modal.squad.delete_group_title'),
        type: 'button',
        onclick: e => {
          e.stopPropagation();
          this.squadGroups.splice(gIdx, 1);
          this.saveDraft();
          m.redraw();
        }
      })])]);
    }))]), m('.list-actions', {
      style: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center'
      }
    }, [m(Button, {
      className: 'Button Button--primary add-group-btn-main',
      icon: 'fas fa-plus',
      type: 'button',
      onclick: () => {
        this.newGroupName('');
        this.squadStep('create_group_name');
        m.redraw();
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.squad.create_group')), this.squadGroups.length > 0 && m(Button, {
      className: 'Button Button--secondary delete-squad-btn-main',
      icon: 'fas fa-trash-alt',
      type: 'button',
      onclick: () => {
        if (confirm(app.translator.trans('bizkaitarra-lineup.forum.modal.squad.delete_squad_confirm').toString())) {
          this.squadGroups = [];
          this.saveDraft();
          m.redraw();
        }
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.squad.delete_squad'))])]);
  }
  renderSquadGroupNameForm() {
    const suggestions = [{
      key: 'goalkeeper',
      default: 'Portero'
    }, {
      key: 'defender',
      default: 'Defensa'
    }, {
      key: 'midfielder',
      default: 'Centro del campo'
    }, {
      key: 'forward',
      default: 'Delantera'
    }];
    return m('.LineupModal-squad-group-name-form', [m('.form-header', [m('span.form-header-title', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.new_group_title')), m('span.form-header-help', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.new_group_help'))]), m('.suggestions-pills', suggestions.map(s => {
      const label = app.translator.trans("bizkaitarra-lineup.forum.modal.squad.suggested_title_".concat(s.key));
      const labelStr = String(label);
      return m('button.suggestion-pill', {
        type: 'button',
        onclick: () => {
          this.addGroup(labelStr || s.default);
        }
      }, [m('i.fas.fa-folder-plus'), " ".concat(labelStr || s.default)]);
    })), m('.custom-name-field', [m('input.FormControl.custom-group-name-input', {
      type: 'text',
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.modal.squad.custom_name_placeholder'),
      value: this.newGroupName(),
      oninput: e => this.newGroupName(e.target.value),
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (this.newGroupName().trim()) {
            this.addGroup(this.newGroupName().trim());
          }
        }
      },
      oncreate: vnode => {
        setTimeout(() => {
          if (vnode.dom) vnode.dom.focus();
        }, 50);
      }
    })]), m('.form-actions', [m(Button, {
      className: 'Button Button--secondary btn-cancel',
      type: 'button',
      onclick: () => {
        this.squadStep('list');
        m.redraw();
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.squad.btn_back')), m(Button, {
      className: 'Button Button--primary btn-continue',
      disabled: !this.newGroupName().trim(),
      type: 'button',
      onclick: () => {
        this.addGroup(this.newGroupName().trim());
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.squad.btn_continue'))])]);
  }
  renderSquadGroupPlayersEditor() {
    const gIdx = this.activeGroupIndex();
    const group = this.squadGroups[gIdx];
    if (!group) {
      this.squadStep('list');
      return null;
    }
    const activeGIdx = this.activeGroupIndex();
    const activePIdx = this.activeSquadPlayerIndex();
    return m('.LineupModal-squad-players-editor', [m('.editor-header', [m(Button, {
      className: 'Button Button--secondary back-to-list-btn',
      icon: 'fas fa-arrow-left',
      type: 'button',
      onclick: () => {
        this.squadStep('list');
        m.redraw();
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.squad.back_to_list')), m('.editor-group-title', [m('input.group-title-input-editor', {
      type: 'text',
      value: group.title(),
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.modal.squad.group_title_placeholder'),
      oninput: e => {
        group.title(e.target.value);
        this.saveDraft();
      }
    })])]), m('.players-list-scroll', [m('.preview-card-list', group.players.map((player, pIdx) => {
      const isActivePlayer = activeGIdx === gIdx && activePIdx === pIdx;
      if (isActivePlayer) {
        return m('.preview-player-item.active.editing', {
          onclick: e => e.stopPropagation()
        }, [m('input.preview-player-number-input', {
          type: 'text',
          value: player.number(),
          placeholder: '#',
          oninput: e => {
            player.number(e.target.value);
            this.saveDraft();
          },
          onkeydown: e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              const nameInput = document.getElementById("squad-player-name-".concat(gIdx, "-").concat(pIdx));
              if (nameInput) nameInput.focus();
            }
          }
        }), m('input.preview-player-name-input', {
          id: "squad-player-name-".concat(gIdx, "-").concat(pIdx),
          type: 'text',
          value: this.searchQuery() !== '' ? this.searchQuery() : player.name(),
          placeholder: 'Buscar o escribir...',
          oninput: e => {
            this.searchQuery(e.target.value);
            player.name(e.target.value);
            this.saveDraft();
          },
          onkeydown: e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.advanceSquadPlayer();
            }
          },
          oncreate: vnode => {
            setTimeout(() => {
              if (vnode.dom) {
                vnode.dom.focus();
                vnode.dom.select();
              }
            }, 50);
          }
        }), m('button.delete-player-btn', {
          type: 'button',
          onclick: e => {
            e.stopPropagation();
            group.players.splice(pIdx, 1);
            if (group.players.length === 0) {
              group.players.push({
                number: Stream(''),
                name: Stream('')
              });
            }
            this.saveDraft();
            if (this.activeSquadPlayerIndex() >= group.players.length) {
              this.activeSquadPlayerIndex(group.players.length - 1);
            }
            m.redraw();
          }
        }, m('i.fas.fa-times'))]);
      }
      return m('.preview-player-item', {
        className: isActivePlayer ? 'active' : '',
        onclick: e => {
          e.stopPropagation();
          this.activeGroupIndex(gIdx);
          this.activeSquadPlayerIndex(pIdx);
          this.searchQuery('');
          m.redraw();
        }
      }, [m('span.preview-player-dorsal', player.number() || '?'), m('span.preview-player-name', player.name() || 'Seleccionar...'), m('button.delete-player-btn', {
        type: 'button',
        onclick: e => {
          e.stopPropagation();
          group.players.splice(pIdx, 1);
          if (group.players.length === 0) {
            group.players.push({
              number: Stream(''),
              name: Stream('')
            });
          }
          this.saveDraft();
          if (this.activeSquadPlayerIndex() >= group.players.length) {
            this.activeSquadPlayerIndex(group.players.length - 1);
          }
          m.redraw();
        }
      }, m('i.fas.fa-times'))]);
    }))]), m('.editor-actions', [m('button.add-player-btn-inline', {
      type: 'button',
      onclick: e => {
        e.stopPropagation();
        group.players.push({
          number: Stream(''),
          name: Stream('')
        });
        this.activeGroupIndex(gIdx);
        this.activeSquadPlayerIndex(group.players.length - 1);
        this.searchQuery('');
        this.saveDraft();
        m.redraw();
        setTimeout(() => {
          const input = document.getElementById("squad-player-name-".concat(gIdx, "-").concat(group.players.length - 1));
          if (input) {
            input.focus();
          }
        }, 50);
      }
    }, [m('i.fas.fa-plus'), ' ', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.add_player')]), m(Button, {
      className: 'Button Button--primary finish-editing-btn',
      type: 'button',
      onclick: () => {
        this.squadStep('list');
        m.redraw();
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.squad.finish_editing'))])]);
  }
  content() {
    var _this$kits$find;
    if (this.editorMode() === 'squad') {
      const step = this.squadStep();
      const isEditing = step === 'edit_group_players';
      return m('.Modal-body', [m('.LineupModal-layout', {
        className: isEditing ? 'LineupModal-layout--editing' : 'LineupModal-layout--full'
      }, [
      // Left Column / Full Width Pane
      m('.LineupModal-pitch-pane', {
        style: isEditing ? {} : {
          width: '100%',
          flex: '0 0 100%',
          maxWidth: 'none'
        }
      }, [this.renderSquadPreview()]),
      // Right Column (Only shown when editing players inside a group)
      isEditing && m('.LineupModal-control-pane', [m('.control-pane-help-text', [m('p', [m('strong', app.translator.trans('bizkaitarra-lineup.forum.modal.squad.help_search_title')), app.translator.trans('bizkaitarra-lineup.forum.modal.squad.help_search_desc')])]), this.renderActivePlayerWidgetForSquad(), m('.LineupModal-group-actions', [m(Button, {
        className: 'Button Button--secondary Button--small',
        icon: 'fas fa-trash',
        style: {
          width: '100%',
          marginTop: '10px'
        },
        onclick: () => this.clearLineup()
      }, app.translator.trans('bizkaitarra-lineup.forum.modal.clear_squad'))])])])]);
    }
    const playersString = this.selectedPlayers.map(p => "".concat(p.number(), ":").concat(p.name())).join(',');
    return m('.Modal-body', [m('.LineupModal-layout', [
    // Left Column: Interactive Pitch
    m('.LineupModal-pitch-pane', [m(Lineup, {
      formation: this.formation(),
      players: playersString,
      kit: this.kit(),
      mini: false,
      // Use full-size pitch
      interactive: true,
      activePosition: this.activePosition(),
      onPlayerClick: index => {
        if (index < 11) {
          this.activePosition(index);
          this.searchQuery(''); // Clear search on change
          m.redraw();
        }
      },
      getPositionName: index => this.getPositionName(index)
    }),
    // Bench / Substitutes editor in the modal
    !this.attrs.onlyStarters && m('.LineupModal-bench-container', [m('.bench-header', [m('span.bench-title', 'Banquillo / Suplentes'), m(Button, {
      className: 'Button Button--secondary Button--small',
      icon: 'fas fa-plus',
      type: 'button',
      onclick: () => {
        this.selectedPlayers.push({
          number: Stream(''),
          name: Stream(''),
          id: Stream('')
        });
        this.activePosition(this.selectedPlayers.length - 1);
        this.searchQuery('');
        this.saveDraft();
        m.redraw();
      }
    }, 'Añadir suplente')]), m('.bench-list', this.selectedPlayers.slice(11).map((p, i) => {
      const idx = 11 + i;
      const isActive = this.activePosition() === idx;
      return m('.bench-player-item', {
        className: isActive ? 'active' : '',
        onclick: () => {
          this.activePosition(idx);
          this.searchQuery('');
          m.redraw();
        }
      }, [m('span.bench-player-dorsal', p.number() || '?'), m('span.bench-player-name', p.name() || 'Nuevo Suplente'), m(Button, {
        className: 'Button Button--link Button--icon delete-bench-player',
        icon: 'fas fa-times',
        onclick: e => {
          e.stopPropagation();
          this.selectedPlayers.splice(idx, 1);
          this.saveDraft();
          if (this.activePosition() >= this.selectedPlayers.length) {
            this.activePosition(this.selectedPlayers.length - 1);
          }
          m.redraw();
        }
      })]);
    }))])]),
    // Right Column: Control Pane & Drawer
    m('.LineupModal-control-pane', [
    // Toggles for Formation and Kit (Inline & super clean!)
    m('.Form-group', [m('label', app.translator.trans('bizkaitarra-lineup.forum.modal.formation_label')), m('select.FormControl', {
      value: this.formation(),
      style: {
        height: '52px',
        minHeight: '52px',
        fontSize: '15px',
        padding: '10px 15px',
        borderRadius: '8px',
        border: '1px solid #cbd5e1',
        cursor: 'pointer',
        display: 'block',
        width: '100%',
        boxSizing: 'border-box'
      },
      onchange: e => {
        this.formation(e.target.value);
        this.saveDraft();
      }
    }, [m('option', {
      value: '4-4-2'
    }, '4-4-2'), m('option', {
      value: '4-3-3'
    }, '4-3-3'), m('option', {
      value: '4-2-3-1'
    }, '4-2-3-1'), m('option', {
      value: '4-1-4-1'
    }, '4-1-4-1'), m('option', {
      value: '4-5-1'
    }, '4-5-1'), m('option', {
      value: '3-5-2'
    }, '3-5-2'), m('option', {
      value: '3-4-3'
    }, '3-4-3'), m('option', {
      value: '5-3-2'
    }, '5-3-2'), m('option', {
      value: '5-4-1'
    }, '5-4-1'), m('option', {
      value: '4-3-1-2'
    }, '4-3-1-2 (Diamante)'), m('option', {
      value: '4-2-2-2'
    }, '4-2-2-2'), m('option', {
      value: '3-1-4-2'
    }, '3-1-4-2')])]), m('.Form-group', [m('label', app.translator.trans('bizkaitarra-lineup.forum.modal.select_kit')), m('select.FormControl', {
      value: this.kit(),
      disabled: !!this.attrs.onlyStarters,
      style: {
        height: '52px',
        minHeight: '52px',
        fontSize: '15px',
        padding: '10px 15px',
        borderRadius: '8px',
        border: '1px solid #cbd5e1',
        cursor: this.attrs.onlyStarters ? 'not-allowed' : 'pointer',
        display: 'block',
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: this.attrs.onlyStarters ? '#f1f5f9' : '#fff',
        opacity: this.attrs.onlyStarters ? 0.85 : 1
      },
      onchange: e => {
        if (this.attrs.onlyStarters) return;
        this.kit(e.target.value);
        this.saveDraft();
      }
    }, this.attrs.onlyStarters ? [m('option', {
      value: this.kit()
    }, ((_this$kits$find = this.kits.find(k => k.id === this.kit())) == null ? void 0 : _this$kits$find.name) || 'Athletic Club')] : this.kits.map(kit => m('option', {
      value: kit.id
    }, kit.name)))]),
    // Active Player Editor Widget
    this.renderActivePlayerWidget(),
    // Preset actions / recent lineups select
    m('.LineupModal-quick-actions', [this.recentLineups.length > 0 && m('.Form-group', {
      style: {
        width: '100%',
        marginBottom: '10px'
      }
    }, [m('label', {
      style: {
        display: 'block',
        marginBottom: '5px',
        fontSize: '12px',
        fontWeight: 'bold'
      }
    }, 'Cargar alineación anterior:'), m('select.FormControl', {
      style: {
        height: '52px',
        minHeight: '52px',
        fontSize: '15px',
        padding: '10px 15px',
        borderRadius: '8px',
        border: '1px solid #cbd5e1',
        cursor: 'pointer',
        display: 'block',
        width: '100%',
        boxSizing: 'border-box'
      },
      onchange: e => {
        const selectedId = parseInt(e.target.value);
        const selectedLineup = this.recentLineups.find(l => l.id === selectedId);
        if (selectedLineup) {
          this.loadLineup(selectedLineup);
        }
        e.target.value = ''; // Reset select
      }
    }, [m('option', {
      value: ''
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.recent_lineups_placeholder')), this.recentLineups.map(l => m('option', {
      value: l.id
    }, l.label))])]), m(Button, {
      className: 'Button Button--secondary Button--small',
      icon: 'fas fa-trash',
      style: {
        width: '100%',
        marginTop: '5px'
      },
      onclick: () => this.clearLineup()
    }, app.translator.trans('bizkaitarra-lineup.forum.modal.clear_lineup'))])])])]);
  }
  renderActivePlayerWidget() {
    const activeIdx = this.activePosition();
    const activePlayer = this.selectedPlayers[activeIdx];
    const posName = this.getPositionName(activeIdx);
    const query = this.searchQuery();
    return m('.LineupModal-active-selection', [m('.selection-header', {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, [m('div', [m('h4', {
      style: {
        display: 'inline-block',
        margin: 0
      }
    }, posName)]),
    // Navigation buttons
    m('.LineupModal-nav-buttons', {
      style: {
        display: 'flex',
        gap: '6px'
      }
    }, [m(Button, {
      className: 'Button Button--secondary Button--icon Button--small',
      icon: 'fas fa-chevron-left',
      onclick: () => {
        const len = this.selectedPlayers.length;
        const prevIdx = (activeIdx - 1 + len) % len;
        this.activePosition(prevIdx);
        this.searchQuery('');
        m.redraw();
        setTimeout(() => {
          const input = document.getElementById('lineup-player-search');
          if (input) {
            input.focus();
            input.select();
          }
        }, 50);
      }
    }), m(Button, {
      className: 'Button Button--secondary Button--icon Button--small',
      icon: 'fas fa-chevron-right',
      onclick: () => {
        this.advanceFrom(activeIdx);
      }
    })])]), m('.team-filter-wrapper', {
      style: {
        marginBottom: '10px'
      }
    }, [m('select.FormControl', {
      value: this.selectedTeamId(),
      onchange: e => {
        this.selectedTeamId(e.target.value);
        m.redraw();
      },
      style: {
        width: '100%',
        height: '38px',
        borderRadius: '6px',
        border: '1px solid #cbd5e1',
        padding: '0 10px',
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        opacity: 1
      }
    }, this.attrs.onlyStarters ? [m('option', {
      value: 'all'
    }, app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad' ? 'Todos los equipos' : 'Todos (1er equipo, Bilbao Athletic, Basconia)'), this.getAllowedTeams().map(team => {
      const id = String(team.id());
      const name = team.name();
      const primaryTeamId = this.attrs.match && typeof this.attrs.match.teamId === 'function' && this.attrs.match.teamId() ? String(this.attrs.match.teamId()) : app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
      const isPrimary = id === String(primaryTeamId) || id === '531';
      const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
      const label = isPrimary && !isRealSociedad ? "".concat(name, " (Primer equipo)") : name;
      return m('option', {
        value: id
      }, label);
    })] : [m('option', {
      value: 'all'
    }, 'Todos los equipos'), this.getTeams().map(team => m('option', {
      value: String(team.id())
    }, team.name()))])]), m('.search-wrapper', {
      style: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        position: 'relative'
      }
    }, [m('input.FormControl#lineup-player-search', {
      type: 'text',
      placeholder: 'Buscar o escribir jugador...',
      value: query || activePlayer.name(),
      style: {
        flex: 1
      },
      oninput: e => {
        const val = e.target.value;
        this.searchQuery(val);
        activePlayer.name(val);
        if (activePlayer.id && activePlayer.id()) {
          const currentId = activePlayer.id();
          const pObj = this.players ? this.players.find(p => String(p.id()) === String(currentId)) : null;
          if (pObj) {
            const normTyped = normalizePlayerIdentifier(val);
            const normPName = normalizePlayerIdentifier(pObj.name());
            const aliases = (pObj.attribute('aliases') || '').split(/[,;]/).map(a => normalizePlayerIdentifier(a));
            if (normTyped !== normPName && !aliases.includes(normTyped)) {
              activePlayer.id('');
            }
          } else {
            activePlayer.id('');
          }
        }
        this.saveDraft();
      },
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.commitOrAdvance(activeIdx);
        }
      }
    }),
    // Committing "next" button inline for mouse users
    m(Button, {
      className: 'Button Button--secondary',
      icon: 'fas fa-chevron-right',
      style: {
        height: '36px',
        display: 'flex',
        alignItems: 'center'
      },
      onclick: () => {
        this.commitOrAdvance(activeIdx);
      }
    }, 'Siguiente')]), query && this.renderWidgetSuggestions(query, activeIdx),
    // If a player is assigned, show their details
    activePlayer.name() && m('div', {
      style: {
        marginTop: '10px',
        fontSize: '12px',
        color: '#666',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, [m('span', [m('strong', 'Jugador: '), "".concat(activePlayer.name(), " ").concat(activePlayer.number() ? "(#".concat(activePlayer.number(), ")") : '')]), m(Button, {
      className: 'Button Button--link Button--icon',
      icon: 'fas fa-times-circle',
      style: {
        color: '#EE2523',
        padding: 0
      },
      onclick: () => {
        activePlayer.name('');
        activePlayer.number('');
        if (activePlayer.id) activePlayer.id('');
        this.searchQuery('');
        this.saveDraft();
        m.redraw();
      }
    })]),
    // Squad list quick chips!
    this.renderSquadDrawer(activeIdx)]);
  }
  renderActivePlayerWidgetForSquad() {
    const gIdx = this.activeGroupIndex();
    const activeGroup = this.squadGroups[gIdx];
    if (!activeGroup) return null;
    const pIdx = this.activeSquadPlayerIndex();
    const activePlayer = activeGroup.players[pIdx];
    if (!activePlayer) return null;
    const query = this.searchQuery();
    return m('.LineupModal-active-selection', [m('.selection-header', [m('h4', "Editar jugador en ".concat(activeGroup.title())), m('span.position-badge', "#".concat(pIdx + 1))]), m('.team-filter-wrapper', {
      style: {
        marginBottom: '10px'
      }
    }, [m('select.FormControl', {
      value: this.selectedTeamId(),
      onchange: e => {
        this.selectedTeamId(e.target.value);
        m.redraw();
      },
      style: {
        width: '100%',
        height: '38px',
        borderRadius: '6px',
        border: '1px solid #cbd5e1',
        padding: '0 10px',
        fontSize: '14px',
        cursor: 'pointer'
      }
    }, [m('option', {
      value: 'all'
    }, 'Todos los equipos'), this.getTeams().map(team => m('option', {
      value: String(team.id())
    }, team.name()))])]), m('.search-wrapper', {
      style: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        position: 'relative'
      }
    }, [m('input.FormControl#lineup-player-search', {
      type: 'text',
      placeholder: 'Buscar o escribir jugador...',
      value: query || activePlayer.name(),
      style: {
        flex: 1
      },
      oninput: e => {
        this.searchQuery(e.target.value);
        activePlayer.name(e.target.value);
        this.saveDraft();
      },
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.advanceSquadPlayer();
        }
      }
    }), m(Button, {
      className: 'Button Button--secondary',
      icon: 'fas fa-chevron-right',
      style: {
        height: '36px',
        display: 'flex',
        alignItems: 'center'
      },
      onclick: () => {
        this.advanceSquadPlayer();
      }
    }, 'Siguiente')]), query && this.renderWidgetSuggestions(query, pIdx), activePlayer.name() && m('div', {
      style: {
        marginTop: '10px',
        fontSize: '12px',
        color: '#666',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, [m('span', [m('strong', 'Jugador: '), "".concat(activePlayer.name(), " ").concat(activePlayer.number() ? "(#".concat(activePlayer.number(), ")") : '')]), m(Button, {
      className: 'Button Button--link Button--icon',
      icon: 'fas fa-times-circle',
      style: {
        color: '#EE2523',
        padding: 0
      },
      onclick: () => {
        activePlayer.name('');
        activePlayer.number('');
        this.searchQuery('');
        this.saveDraft();
        m.redraw();
      }
    })]), this.renderSquadDrawer(pIdx)]);
  }
  renderWidgetSuggestions(query, index) {
    const suggestions = this.getSuggestions(query, 'name', index);
    if (suggestions.length === 0) return null;
    return m('ul.Lineup-suggestions', suggestions.map(p => m('li', {
      onclick: () => {
        this.selectPlayer(p.name(), p.number() ? p.number().toString() : '', p.id() ? String(p.id()) : '');
      }
    }, [m('span.suggestion-number', p.number()), m('span.suggestion-name', p.name())])));
  }
  renderSquadDrawer(activeIdx) {
    if (!this.players || this.players.length === 0) return null;
    const query = normalizeSearchText(this.searchQuery());
    const selectedNames = this.getSelectedPlayerNames(activeIdx);
    let list = this.players.filter(p => p.attribute('entityType') === 'player' && (typeof p.isActive === 'function' ? p.isActive() !== false : true) && !selectedNames.includes(normalizePlayerIdentifier(p.name())));
    if (this.attrs.onlyStarters) {
      const allowedTeamIds = this.getAllowedTeamIds();
      list = list.filter(p => {
        const playerTeams = p.teams() || [];
        return playerTeams.length === 0 || playerTeams.some(t => allowedTeamIds.includes(String(t.id())));
      });
    }
    if (this.selectedTeamId() && this.selectedTeamId() !== 'all') {
      list = list.filter(p => {
        const playerTeams = p.teams() || [];
        return playerTeams.some(t => String(t.id()) === String(this.selectedTeamId()));
      });
    }
    if (query) {
      list = list.filter(p => {
        if (matchesSearch(p.name(), query)) return true;
        const aliases = (p.attribute('aliases') || '').split(/[;,]/);
        return aliases.some(alias => matchesSearch(alias, query));
      });
    }
    const sortedList = [...list].sort((a, b) => {
      const scoreA = this.getPlayerPriorityScore(a, activeIdx);
      const scoreB = this.getPlayerPriorityScore(b, activeIdx);
      if (scoreA !== scoreB) {
        return scoreB - scoreA;
      }
      const numA = parseInt(a.number() || '99');
      const numB = parseInt(b.number() || '99');
      return numA - numB;
    });
    return m('.LineupModal-squad-drawer', [m('.squad-title', 'Selección rápida:'), m('.squad-grid', sortedList.map(p => m('span.squad-chip', {
      onclick: () => {
        this.selectPlayer(p.name(), p.number() ? p.number().toString() : '', p.id() ? String(p.id()) : '');
      }
    }, [p.number() ? m('strong', "#".concat(p.number(), " ")) : '', p.name()])))]);
  }
  insertLineup() {
    if (this.editorMode() === 'squad') {
      const cleanStr = s => (s || '').replace(/[|=:]/g, '');
      const squadData = this.squadGroups.map(g => {
        const title = cleanStr(g.title().trim());
        const players = g.players.filter(p => p.name() && p.name().trim() !== '' && p.name() !== '?').map(p => ({
          number: cleanStr(p.number()),
          name: cleanStr(p.name())
        }));
        return {
          title,
          players
        };
      }).filter(g => g.title && g.players.length > 0);
      if (squadData.length === 0) {
        this.hide();
        return;
      }
      const rawString = squadData.map(g => {
        const playersStr = g.players.map(p => "".concat(p.number || '?', ":").concat(p.name)).join(',');
        return "".concat(g.title, "=").concat(playersStr);
      }).join('|');
      const bbcode = "[squad]".concat(rawString, "[/squad]");
      this.attrs.onsubmit(bbcode);
      this.hide();
      return;
    }
    let activePlayers = [...this.selectedPlayers];
    while (activePlayers.length > 11 && !activePlayers[activePlayers.length - 1].name()) {
      activePlayers.pop();
    }

    // Exclusivamente para 11 Aldeanos (onlyStarters === true)
    if (this.attrs.onlyStarters) {
      const starters = activePlayers.slice(0, 11);
      if (starters.length < 11) {
        app.alerts.show({
          type: 'error'
        }, 'En 11 Aldeanos debes completar los 11 jugadores titulares.');
        return;
      }
      const starterIds = [];
      for (let i = 0; i < 11; i++) {
        const p = starters[i];
        let pid = p.id ? p.id() : '';

        // Intentar auto-resolver si falta ID pero hay nombre
        if (!pid && p.name() && this.players) {
          const norm = normalizePlayerIdentifier(p.name());
          const matched = this.players.find(pl => {
            const plName = normalizePlayerIdentifier(pl.name());
            if (plName === norm) return true;
            const aliases = (pl.attribute('aliases') || '').split(/[,;]/).map(a => normalizePlayerIdentifier(a));
            return aliases.includes(norm);
          });
          if (matched) {
            pid = String(matched.id());
            if (p.id) p.id(pid);
            if (matched.number() && (!p.number() || p.number() === '?')) {
              p.number(String(matched.number()));
            }
          }
        }
        if (!pid || !p.name() || p.name() === '?') {
          app.alerts.show({
            type: 'error'
          }, "El titular en la posici\xF3n #".concat(i + 1, " no es un jugador v\xE1lido de la plantilla."));
          this.activePosition(i);
          return;
        }
        if (this.players) {
          const plObj = this.players.find(pl => String(pl.id()) === pid);
          if (plObj) {
            const allowedTeamIds = this.getAllowedTeamIds();
            const playerTeams = plObj.teams() || [];
            const belongsToAllowed = playerTeams.length === 0 || playerTeams.some(t => allowedTeamIds.includes(String(t.id())));
            if (!belongsToAllowed) {
              const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
              const msg = isRealSociedad ? "El titular \"".concat(plObj.name(), "\" no pertenece a la plantilla de la Real Sociedad.") : "El titular \"".concat(plObj.name(), "\" debe pertenecer al primer equipo, Bilbao Athletic o Basconia.");
              app.alerts.show({
                type: 'error'
              }, msg);
              this.activePosition(i);
              return;
            }
          }
        }
        if (starterIds.includes(pid)) {
          app.alerts.show({
            type: 'error'
          }, "El jugador \"".concat(p.name(), "\" est\xE1 repetido en la alineaci\xF3n. No puedes alinear al mismo jugador m\xE1s de una vez."));
          this.activePosition(i);
          return;
        }
        starterIds.push(pid);
      }
    }
    const cleanStr = s => (s || '').replace(/[\\:,|\[\]\r\n\t]/g, ' ').replace(/\s+/g, ' ').trim();
    const playersData = activePlayers.map(p => {
      const rawNum = cleanStr(p.number());
      const num = rawNum || '?';
      const rawName = cleanStr(p.name());
      const name = rawName || '?';
      let id = p.id && p.id() ? String(p.id()).trim() : '';

      // Guard against residual/stale player IDs if user typed a different name
      if (id && this.players) {
        const pObj = this.players.find(pl => String(pl.id()) === id);
        if (pObj) {
          const normTyped = normalizePlayerIdentifier(name);
          const normPName = normalizePlayerIdentifier(pObj.name());
          const aliases = (pObj.attribute('aliases') || '').split(/[,;]/).map(a => normalizePlayerIdentifier(a));
          if (normTyped !== normPName && !aliases.includes(normTyped)) {
            id = '';
          }
        }
      }
      return id ? "".concat(num, ":").concat(id, ":").concat(name) : "".concat(num, ":").concat(name);
    });
    const playersRaw = playersData.join(',');
    const bbcode = "[lineup formation=\"".concat(this.formation(), "\" kit=\"").concat(this.kit(), "\"]").concat(playersRaw, "[/lineup]");

    // Check if there are exactly 11 valid starting players assigned
    const validStarters = this.selectedPlayers.slice(0, 11).filter(p => p.name() && p.name().trim() !== '' && p.name() !== '?');
    if (validStarters.length === 11) {
      app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/my-recent-lineups"),
        body: {
          formation: this.formation(),
          kit: this.kit(),
          players_raw: playersRaw
        }
      }).catch(err => {
        console.error('Failed to save recent lineup:', err);
      });
    }
    this.attrs.onsubmit(bbcode);
    this.hide();
  }
  onready() {
    const modalContainer = document.querySelector('.ModalManager.modal');
    if (modalContainer) {
      modalContainer.scrollTop = 0;
    }
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/LineupModal', LineupModal);